import { render } from "./EditBusinessRule.vue?vue&type=template&id=3fd71f02"
import script from "./EditBusinessRule.vue?vue&type=script&lang=js"
export * from "./EditBusinessRule.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__